import {FC} from 'react'

import {getTeamContent} from '@/content/teamContent'
import {useTranslation} from '@/i18n'

import {Text, TextVariant} from '../content/Text'
import {TeamCategoryTabs} from './TeamCategoryTabs'

export const Team: FC = () => {
  const {t} = useTranslation()
  const {title} = getTeamContent()

  return (
    <>
      <Text variant={TextVariant.h2} align="center">
        {t(title)}
      </Text>
      <TeamCategoryTabs />
    </>
  )
}
